import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=7c4536d9&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4536d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c4536d9')) {
      api.createRecord('7c4536d9', component.options)
    } else {
      api.reload('7c4536d9', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=7c4536d9&scoped=true&", function () {
      api.rerender('7c4536d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DWSnXmS2WFG3/JS/comp/Voucher-Unit.vue"
export default component.exports